import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './store';

export type folderStateType = {
  folderId: string;
  folderName?: string;
};

const initialState: folderStateType = {
  folderId: '',
  folderName: ''
};

export const folderStateSlice = createSlice({
  name: 'folderStateSlice',
  initialState,
  reducers: {
    setFolderDetails: (state, action) => {
      state = { ...action.payload };
      return state;
    },
    resetFolderDetails: () => {
      return initialState;
    }
  }
});

export const { setFolderDetails, resetFolderDetails } =
  folderStateSlice.actions;

export const getFolderDetails = (state: RootState) => state.folderStateSlice;
